import styled from 'styled-components';

const StyledLoading = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100%;
    background: #F5F9FF;
    -webkit-font-smoothing: antialiased;

    * {
        box-sizing: border-box;

        &::before,
        &::after {
            box-sizing: border-box;
        }
    }

    .loader {
        position: relative;
        display: inline-block;
        width: 44px;
        height: 44px;
        margin: 0 16px;

        --path: #2F3545;
        --dot: #08979c;
        --duration: 3s;

        &::before {
            position: absolute;
            top: 37px;
            left: 19px;
            display: block;
            width: 8px;
            height: 8px;
            content: '';
            background: var(--dot);
            border-radius: 50%;
            transform: translate(-18px, -18px);
            animation: dotRect var(--duration) cubic-bezier(0.785, 0.135, 0.15, 0.86) infinite;
        }

        svg {
            display: block;
            width: 100%;
            height: 100%;

            rect,
            polygon,
            circle {
                fill: none;
                stroke: var(--path);
                stroke-linecap: round;
                stroke-linejoin: round;
                stroke-width: 12px;
            }

            polygon {
                stroke-dasharray: 145 calc(221 - 145) 145 calc(221 - 145);
                stroke-dashoffset: 0;
                animation: pathTriangle var(--duration) cubic-bezier(0.785, 0.135, 0.15, 0.86) infinite;
            }

            rect {
                stroke-dasharray: calc(256 / 4 * 3) calc(256 / 4) calc(256 / 4 * 3) calc(256 / 4);
                stroke-dashoffset: 0;
                animation: pathRect 3s cubic-bezier(0.785, 0.135, 0.15, 0.86) infinite;
            }

            circle {
                stroke-dasharray: calc(200 / 4 * 3) calc(200 / 4) calc(200 / 4 * 3) calc(200 / 4);
                stroke-dashoffset: 75;
                animation: pathCircle var(--duration) cubic-bezier(0.785, 0.135, 0.15, 0.86) infinite;
            }
        }

        &.triangle {
            width: 48px;

            &::before {
                left: 21px;
                transform: translate(-10px, -18px);
                animation: dotTriangle var(--duration) cubic-bezier(0.785, 0.135, 0.15, 0.86) infinite;
            }
        }
    }

    @keyframes pathTriangle {
        33% {
            stroke-dashoffset: 74;
        }

        66% {
            stroke-dashoffset: 147;
        }

        100% {
            stroke-dashoffset: 221;
        }
    }

    @keyframes dotTriangle {
        33% {
            transform: translate(0, 0);
        }

        66% {
            transform: translate(10px, -18px);
        }

        100% {
            transform: translate(-10px, -18px);
        }
    }

    @keyframes pathRect {
        25% {
            stroke-dashoffset: 64;
        }

        50% {
            stroke-dashoffset: 128;
        }

        75% {
            stroke-dashoffset: 192;
        }

        100% {
            stroke-dashoffset: 256;
        }
    }

    @keyframes dotRect {
        25% {
            transform: translate(0, 0);
        }

        50% {
            transform: translate(18px, -18px);
        }

        75% {
            transform: translate(0, -36px);
        }

        100% {
            transform: translate(-18px, -18px);
        }
    }

    @keyframes pathCircle {
        25% {
            stroke-dashoffset: 125;
        }

        50% {
            stroke-dashoffset: 175;
        }

        75% {
            stroke-dashoffset: 225;
        }

        100% {
            stroke-dashoffset: 275;
        }
    }

`;
export default StyledLoading;
